import {
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { NavLink } from "react-router-dom";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import React from "react";
import { useTheme } from "@emotion/react";
import Logo from "../../Logo/homelys_logo.png";

const Sidebar = ({ drawerOpen, handleDrawerClose, pages }) => {
  const theme = useTheme();
  return (
    <Drawer
      variant="temporary"
      anchor="left"
      open={drawerOpen}
      onClose={handleDrawerClose}
      PaperProps={{
        sx: {
          width: { xs: "min(340px, 88vw)", sm: 380 },
          color: "#f6f4ef",
          backgroundColor: "#292720",
          boxShadow: "20px 0 70px rgba(20,19,16,0.28)",
        },
      }}
    >
      <Box
        sx={{
          minHeight: 86,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          px: { xs: 2.5, sm: 3.5 },
          py: 2,
        }}
      >
        <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}>
          <img
            src={Logo}
            alt="Homely Buildofiy"
            style={{
              width: 156,
              maxWidth: "90%",
              filter: "drop-shadow(0 2px 8px rgba(0,0,0,0.12))",
            }}
          />
        </Box>
        <IconButton
          onClick={handleDrawerClose}
          aria-label="Close menu"
          sx={{
            color: "#f6f4ef",
            border: "1px solid rgba(246,244,239,0.22)",
            "&:hover": {
              color: "#d5bd91",
              borderColor: "#a68757",
              backgroundColor: "rgba(246,244,239,0.06)",
            },
          }}
        >
          {theme.direction === "rtl" ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </IconButton>
      </Box>
      <Divider sx={{ borderColor: "rgba(246,244,239,0.16)" }} />
      <Box sx={{ px: { xs: 3, sm: 4 }, pt: 4, pb: 1 }}>
        <Box
          sx={{
            color: "#c7b896",
            fontSize: "0.65rem",
            fontWeight: 600,
            letterSpacing: "0.19em",
            textTransform: "uppercase",
          }}
        >
          Explore Homely
        </Box>
      </Box>
      <List sx={{ px: { xs: 2, sm: 3 }, py: 1 }}>
        {pages.map((page, index) => (
          <ListItem key={page.path || index} disablePadding sx={{ display: "block" }}>
            <ListItemButton
              sx={{
                textDecoration: "none",
                minHeight: 62,
                justifyContent: "flex-start",
                gap: 2,
                px: 2,
                color: "rgba(246,244,239,0.82)",
                borderBottom: "1px solid rgba(246,244,239,0.12)",
                "&.active": {
                  color: "#e2c796",
                  backgroundColor: "rgba(246,244,239,0.05)",
                },
                "&:hover": {
                  color: "#e2c796",
                  backgroundColor: "rgba(246,244,239,0.06)",
                },
                "&:hover .menu-arrow": {
                  transform: "translateX(3px)",
                },
              }}
              component={NavLink}
              to={page.path}
            >
              <Box
                component="span"
                sx={{
                  minWidth: 24,
                  color: "#a68757",
                  fontSize: "0.66rem",
                  letterSpacing: "0.08em",
                }}
              >
                {String(index + 1).padStart(2, "0")}
              </Box>
              <ListItemText
                primary={page.name}
                primaryTypographyProps={{
                  sx: {
                    fontFamily: 'Georgia, "Times New Roman", serif',
                    fontSize: "1.18rem",
                  },
                }}
              />
              <ArrowForwardIosIcon
                className="menu-arrow"
                sx={{
                  color: "rgba(213,189,145,0.72)",
                  fontSize: 12,
                  transition: "transform 180ms ease",
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Box
        sx={{
          mt: "auto",
          px: { xs: 3, sm: 4 },
          py: 3,
          color: "rgba(246,244,239,0.5)",
          fontSize: "0.72rem",
          letterSpacing: "0.04em",
        }}
      >
        Thoughtfully built for the way you live.
      </Box>
    </Drawer>
  );
};

export { Sidebar };
